import { formatDate } from "utils/function-utils";
export const ProfileId = {
  id: "ProfileId",
  title: "Profile Id",
  style: { width: "130px" },
  render: (item) => {
    return item.ProfileId;
  },
};

export const Platform = {
  id: "Platform",
  title: "Platform",
  style: { width: "100px" },
  render: (item) => {
    return item.MES;
  },
};

export const Scope = {
  id: "Scope",
  title: "Scope",
  style: { width: "136px" },
  render: (item) => {
    return item.Scope;
  },
};

export const Stage = {
  id: "Stage",
  title: "Stage",
  style: { width: "100px" },
  render: (item) => {
    return item.Stage;
  },
};

export const ProfileName = {
  id: "ProfileName",
  title: "Profile Name",
  style: { width: "250px" },
  render: (item) => {
    return item.ProfileName;
  },
};

export const Host = {
  id: "Host",
  title: "Host",
  style: {},
  render: (item) => {
    return item.Host;
  },
};

export const Description = {
  id: "Description",
  title: "Description",
  style: { width: "300px" },
  render: (item) => {
    return item.Description;
  },
};

export const CreateDate = {
  id: "CreateDate",
  title: "Create Date",
  style: {},
  render: (item) => {
    return item.CreateDate && formatDate(item.CreateDate);
  },
};
